import { render, staticRenderFns } from "./NightHuntIngredient.vue?vue&type=template&id=ef9aebdc&scoped=true"
import script from "./NightHuntIngredient.vue?vue&type=script&lang=js"
export * from "./NightHuntIngredient.vue?vue&type=script&lang=js"
import style0 from "./NightHuntIngredient.vue?vue&type=style&index=0&id=ef9aebdc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef9aebdc",
  null
  
)

export default component.exports